import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidFileQuestionAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M15 8h4.4L14 2.6V7c0 .6.4 1 1 1Zm1.4 10c0-.2 0-.4.1-.6-1.3-.4-2.1-1.8-1.7-3.1.1-.2.1-.4.2-.6.8-1.4 2.3-2.2 3.9-2.3.4 0 .7.1 1.1.1V10h-5c-1.7 0-3-1.3-3-3V2H7C5.3 2 4 3.3 4 5v14c0 1.7 1.3 3 3 3h9.6c-.4-.8-.3-1.8.3-2.5-.3-.4-.5-1-.5-1.5ZM9.1 8h1c.6 0 1 .4 1 1s-.4 1-1 1h-1c-.6 0-1-.4-1-1s.4-1 1-1Zm3 10h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.5 1-1 1Zm0-4h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.5 1-1 1Zm6.8 6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Zm0-7c-1.1 0-2.1.6-2.6 1.5-.3.5-.1 1.1.4 1.4.5.3 1.1.1 1.4-.4.2-.3.5-.5.9-.5.6 0 1 .4 1 1s-.4 1-1 1-1 .4-1 1 .4 1 1 1c1.7 0 3-1.3 3-3s-1.4-3-3.1-3Z"/>
  </SvgIcon>
}

export default SolidFileQuestionAltIcon
